const l = {
  name: "Platform",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.7 40" style="enable-background:new 0 0 39.7 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19.9,0l19.9,12l-6.6,4l6.6,4l-6.6,4l6.6,4L19.9,40L0,28l6.6-4L0,20l6.6-4L0,12L19.9,0z M9,15.2l6.6,4l0,0
			l4.3,2.6l4.2-2.5l0,0l6.6-4l0.5-0.4l0,0l4.6-2.8l-16-9.7L3.9,12L9,15.2L9,15.2z M8.5,17.2L3.9,20L9,23.1l0,0l10.9,6.6l10.8-6.5
			l0.5-0.4l0,0l4.6-2.8l-4.6-2.8l-6,3.7l0,0l-5.3,3.2l-5.2-3.2l0,0L8.5,17.2z M8.5,25.2L3.9,28l16,9.7l16-9.7l-4.6-2.8L19.9,32
			L8.5,25.2z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Platform
};
